//#region import libraries
import React from 'react';
//custom components
import { Title, NewScreen } from "_atoms";
import { FlightInformationCard } from '_molecules';
import { FlightForecastTable } from '_organisms';

// bootstrap
import { Row, Col } from 'react-bootstrap';
//#endregion

const FlightInformation = (props) => {

    return (
        <NewScreen>

            {/* Title */}
            <Row>
                <Col>
                    <Title name="Account" subtitle={"Flight Information"} description={"View more information on a flight route"} />
                </Col>
            </Row>

            <Row>
                <FlightInformationCard />
            </Row>

            <Row>
                <FlightForecastTable />
            </Row>

        </NewScreen>
    );
};

export default FlightInformation;
